module.exports = __webpack_public_path__ + "img/金属材料学3_6_1.cc650037.png";